import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../common/Loader';
import { Container } from 'react-bootstrap';
import MetaData from '../MetaData';
import SectionHeading from '../common/SectionHeading';
import { clearErrors } from '../../redux/actions/orderActions';
import { deleteProduct, getAllProducts } from '../../redux/actions/productAction';
import { BsFillTrashFill, BsFillPencilFill } from 'react-icons/bs';
import Table from 'react-bootstrap/Table';
import { useNavigate, Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Row, Col } from 'react-bootstrap';
import { DELETE_PRODUCT_RESET } from '../../redux/constants/productConstants';

const ProductList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, products, error } = useSelector((state) => state.products);
    const { isDeleted, error: deleteError } = useSelector((state) => state.product);

    useEffect(() => {
        if (error) {
            toast.error(error);
            dispatch(clearErrors());
        }
        if (deleteError) {
            toast.error(deleteError);
            dispatch(clearErrors());
        }

        if (isDeleted) {
            toast.success('Product deleted successfully');
            dispatch({ type: DELETE_PRODUCT_RESET });
            navigate('/admin/dashboard');
        }

        dispatch(getAllProducts());
    }, [error, deleteError, isDeleted]);

    const handleDeleteProduct = (id) => {
        dispatch(deleteProduct(id));
    };

    return loading ? (
        <Loader />
    ) : (
        <>
            <MetaData title={`All Products - Admin`} />
            <Container>
                <div className='myOrdersPage section-padding-top section-padding-bottom'>
                    <SectionHeading heading={'All Products'} />
                    <Row>
                        <Col md={3}>
                            <Sidebar />
                        </Col>
                        <Col md={9}>
                            <div className='scrollableTable'>
                                <Table striped bordered hover className='commonTable'>
                                    <thead>
                                        <tr>
                                            <th>OrderID</th>
                                            <th>Status</th>
                                            <th>Items Qty</th>
                                            <th>Amount</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {products &&
                                            products.length > 0 &&
                                            products.map((item, i) => (
                                                <tr key={i}>
                                                    <td>{item._id}</td>
                                                    <td>{item.name}</td>
                                                    <td
                                                        className={
                                                            item.Stock === 0
                                                                ? 'text-danger'
                                                                : 'text-success'
                                                        }
                                                    >
                                                        {item.Stock}
                                                    </td>
                                                    <td>{item.price}</td>
                                                    <td>
                                                        <Link to={`/admin/product/${item._id}`}>
                                                            <BsFillPencilFill />
                                                        </Link>
                                                        <button
                                                            className='common-btn'
                                                            onClick={() =>
                                                                handleDeleteProduct(item._id)
                                                            }
                                                        >
                                                            <BsFillTrashFill />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </>
    );
};

export default ProductList;
